// @module Anchorgroup.GridCartAdder.GridCartAdderMod
define('Anchorgroup.GridCartAdder.GridCartAdderMod.Subtotal'
	, [
		'anchorgroup_gridcartadder_subtotal.tpl'
		, 'Utils'
		, 'Backbone'
		, 'jQuery'
		, 'underscore'
		, 'LiveOrder.Model'
	]
	, function (
		anchorgroup_gridcartadder_subtotal_tpl
		, Utils
		, Backbone
		, jQuery
		, _
		, LiveOrderModel
	) {
		'use strict';
		var self

		return Backbone.View.extend({

			template: anchorgroup_gridcartadder_subtotal_tpl,
			contextDataRequest: ['item']

			, initialize: function (options) {
				var self = this;
				this.cart = options.Cart;
				this.itemId = options.itemId;
				this.amountFormatted = "$0.00";
				//console.log(this.itemId);

				self.updateSubtotals();
					
				//Backbone listener for external change 
				var cartModel = LiveOrderModel.getInstance();
				cartModel.on('change', function (model) {
                    self.updateSubtotals();
                });
			},

			updateSubtotals: function () {
				var self = this;

				self.cart.getLines().then(function (lines) {
					//console.log(lines, lines.length);

					var cartIDArray = [];
					for (var i = 0; i < lines.length; i++) { 
						var itemID = lines[i]['item']['internalid'];

						cartIDArray.push(itemID);
					} 

					//console.log('cartIDArray: ', cartIDArray);
					var itemIDMatch = cartIDArray.indexOf(self.itemId);
					//console.log('itemIDMatch: ', itemIDMatch);
					if (itemIDMatch >= 0) {
						var lineMatch = _.filter(lines, function (line) {
							//console.log(line.item.internalid);
							return line.item.internalid == self.itemId;
						});
						
						self.amountFormatted = lineMatch[0].extras.amount_formatted;
						//console.log('amountFormatted', self.amountFormatted)
						self.render();
					} else {
						self.amountFormatted = "$0.00";
						self.render();
					}
				});
			}

			, getContext: function getContext() {
				return {
					itemid: this.parentView.model.get('internalid'),
					subtotal: this.amountFormatted
				};
			}
		});
	});
